import Page from "./Page.vue";

function getRating(point) {
  if (point >= 25) return { name: "H", color: "#E42728" };
  else if (point >= 15) return { name: "M", color: "#EA5455" };
  else if (point >= 5) return { name: "L", color: "#FF9F43" };
  else return { name: "N", color: "#28C76F" };
}

const list = {
  summaryComponent: Page,
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year-range",
        label: "연도",
        value: "yearRange",
        query: { ys: "start", ye: "end" },
        options: {
          yearsBack: 2, // 현재년-2 ~ 현재년 (3년)
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "Head 3"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도 (범위)
    const yr = search.yearRange;
    if (yr && yr.start) {
      conditions.push({ key: "created_at", operator: ">=", value: `${yr.start}-01-01` });
    }
    if (yr && yr.end) {
      conditions.push({ key: "created_at", operator: "<", value: `${Number(yr.end) + 1}-01-01` });
    }

    // 사업장 탭 (fd 쿼리)
    const params = new URLSearchParams(window.location.search);
    const fd = params.get("fd");
    if (fd) {
      conditions.push({ key: "body.stdInfo.field_name", operator: "=", value: fd });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      // 등급(중요도_점수)은 DB에 숫자로 저장되어 있으므로 L/M/N/H 입력을 점수 범위로 변환
      if (search.column.head === "등급") {
        const grade = String(search.column.keyword).trim().toUpperCase();
        const ranges = {
          H: { min: 25 },
          M: { min: 15, max: 25 },
          L: { min: 5, max: 15 },
          N: { max: 5 },
        };
        const range = ranges[grade];
        if (range) {
          if (range.min !== undefined) {
            conditions.push({ key: types[search.column.head], operator: ">=", value: range.min });
          }
          if (range.max !== undefined) {
            conditions.push({ key: types[search.column.head], operator: "<", value: range.max });
          }
        }
      }
      if (search.column.head === "작성부서") {
        conditions.push({ key: types[search.column.head], operator: "LIKE", value: `${search.column.keyword}(%)` });
      } else {
        conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
      }
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "작성부서",
        key: "body.stdInfo.department",
      },
      {
        name: "공장명",
        key: "body.공정분류.공장명",
      },
      {
        name: "공정명",
        key: "body.공정분류.공정명",
      },
      {
        name: "구분",
        key: "body.공정분류.구분",
      },
      {
        name: "활동명",
        key: "body.공정분류.활동명",
      },
      {
        name: "상태",
        key: "body.공정분류.상태",
      },
      {
        name: "관리",
        key: "body.공정분류.관리유형",
      },
      {
        name: "환경측면",
        key: "body.환경영향평가.환경요소_평가[%]",
      },
      {
        name: "등급",
        key: "body.환경영향평가.중요도_점수",
      },
      {
        name: "환경영향",
        key: "body.환경영향평가.환경영향",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 8) {
          return func.getContent(value).환경영향평가.환경요소_평가.join(", ");
        } else if (index === 9) {
          return getRating(func.getContent(value).환경영향평가.중요도_점수).name;
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {}
    return "";
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};

export default list;
